module.exports = __webpack_public_path__ + "static/img/91BM-067-Gavin.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-067-Gavin.jpg
// module id = 4q3M
// module chunks = 0